module.exports = __webpack_public_path__ + "img/medium.a02ec613.png";